export default "__VITE_ASSET__fc9592ce__"